import React, { useState } from 'react';
import * as Styles from './TemplateCard.styles';
import { Button, IconImageError, Skeleton } from 'gatorcomponents';
import { useResize } from '@/hooks/useResize';

const TemplateCard = ({
  testId,
  template,
  openTemplateButtonLabel,
  openTemplate,
  openPreviewButtonLabel,
  openPreview,
  loading = false,
}) => {
  const [imageLoaded, setImageLoaded] = useState(false);
  const [imageError, setImageError] = useState(false);

  const windowRect = useResize();
  const { width } = windowRect;
  const mobile = width <= 600;

  const handleOpenTemplate = () => {
    openTemplate && openTemplate();
  };

  const handleOpenPreview = () => {
    openPreview && openPreview();
  };

  const handleImageError = () => {
    setImageLoaded(true);
    setImageError(true);
  };

  if (loading) {
    return (
      <Styles.Wrapper data-testid={`${testId}-skeleton`}>
        <Styles.CardWrapper>
          <Skeleton width="100%" height="100%" />
        </Styles.CardWrapper>

        <Skeleton width="50%" height="16px" />
      </Styles.Wrapper>
    );
  }

  return (
    <Styles.Wrapper data-testid={testId}>
      <Styles.CardWrapper imageError={imageError}>
        {!imageError ? (
          <Styles.CardImage
            src={template.image}
            alt={template.title}
            onLoad={() => setImageLoaded(true)}
            onError={() => handleImageError()}
            $loaded={imageLoaded}
          />
        ) : (
          <Styles.CardError>
            <IconImageError
              color="lowLight"
              secondaryColor="transparent"
              size="xl"
              testId="IconImageErrorTestId"
            />
          </Styles.CardError>
        )}

        <Styles.SkeletonWrapper $loaded={imageLoaded}>
          <Skeleton width="100%" height="100%" />
        </Styles.SkeletonWrapper>

        <Styles.OverlayWrapper>
          <Styles.OverlayContent>
            <Button
              testId={`${testId}-open-template-button`}
              label={openTemplateButtonLabel}
              onClick={handleOpenTemplate}
              size={mobile ? 'small' : 'medium'}
              inverse
              modifier="inverse"
            />

            {!!template.preview_url && (
              <Button
                testId={`${testId}-open-preview-button`}
                label={openPreviewButtonLabel}
                onClick={handleOpenPreview}
                size={mobile ? 'small' : 'medium'}
                inverse
                modifier="inverse"
              />
            )}
          </Styles.OverlayContent>
        </Styles.OverlayWrapper>
      </Styles.CardWrapper>

      <Styles.CardTitle>{template.title}</Styles.CardTitle>
    </Styles.Wrapper>
  );
};

export default TemplateCard;
